<template>
  <div>
    <BreadCrumb :data="breadCrumb" />
    <Table
      :fields="fields" :items="products" :filtered="filtered" type="List" 
      :loading="isLoading"
    />

  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import Table from "@/components/Table";

let breadCrumb = [
  { label: "Depolar", url: "/Warehouse/List" },
  { label: "Depodaki Ürünler", url: "" },
];

let fields = [
  { key: "barcode", label: "Stok Kodu", keys: ["barcode"] },
  { key: "name", label: "Ürün Adı", keys: ["name"] },
  { key: "quantity", label: "Mevcut Adet", keys: ["total"] },
  { key: "active", label: "Durum", keys: ["active"] }
];

let filtered = ["barcode", "name", "quantity", "active"];

export default {
  name: "WarehouseProduct",
  data: function () {
    return {
      breadCrumb, fields, filtered, params: {},
    };
  },
  components: {
    BreadCrumb,
    Table
  },
  computed: {
    isLoading() {
      return this.$store.getters.getWarehouseLoading
    },
    products() {
      return this.$store.getters.getWarehouseProducts
    },
  },
  methods: {
   
   
  },
  created() {
    this.params.id = this.$route.params.id
    this.$store.dispatch("warehouseproducts_get", this.params);
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/ERP/Warehouse/Products.vue